import { RemoteFormController } from "stimulus-library"

export default class extends RemoteFormController {
  connect() {
    this.el.querySelectorAll("[data-remote=true]").forEach((el) => {
      el.addEventListener('ajax:success', this.replace.bind(this))
      el.addEventListener('ajax:error', this.replace.bind(this))
    })
  }
}